<script>
	import { onMount } from "svelte";

	import Animation from "../../components/AnimationCSS.svelte";
	import Animatable from "../../components/AnimatableCSS.svelte";
	import LazyImgResponsive from "../../components/LazyImgResponsive.svelte";
	import Spread from "../../newspaper/Spread.svelte";

	export let id;
	export let section;
	export let slideProgress;
	export let content = {};
	export let pages;
	export let ipad;
	export let animationDuration = 1000;

	let play;
	let reset;
	let played = false;
	let mounted = false;

	onMount(() => {
		mounted = true;
	});

	$: if (mounted && slideProgress === 0 && played) {
		reset();
		played = false;
	}

	$: if (mounted && slideProgress !== 0 && slideProgress !== 1 && !played) {
		play();
		played = true;
	}
</script>

<div class="text">
	<div class="text-text">
		<div class="t-heading">{@html content.heading}</div>
		<div class="t-text">{@html content.text}</div>
	</div>

	<div class="coop">
		<span class="coop-text">{@html content.text_coop}</span>
		<span class="coop-image">
			<LazyImgResponsive class="coop-logo" src="{PATH}assets/images/icons/handelsblatt.svg" />
		</span>
	</div>
</div>

<div class="animation">
	<Animation duration={animationDuration} bind:play bind:reset>
		{#each pages as page}
			<Animatable left={page.x} top={page.y} anchor={page.anchor || ""} animation={page.animation}>
				<Spread src="{PATH}assets/images/content/{section}_{id}_{page.id}" {...page} />
			</Animatable>
		{/each}
	</Animation>
</div>

<style lang="scss">
	.text {
		@media (min-width: #{$breakpoint-tablet + 1px}) {
			width: 472px;
			max-width: 40%;
			margin-left: 60%;
			position: absolute;
			top: 300px;
			z-index: 1;
		}

		@media (min-width: #{$breakpoint-mobile + 1px}) and (max-width: $breakpoint-tablet) {
			width: 100%;
			max-width: 491px;
			position: absolute;
			top: 70px;
			z-index: 1;
		}

		@media (max-width: $breakpoint-mobile) {
			width: 100%;
			max-width: 620px;
			margin-left: 0;
			position: relative;
			bottom: auto;
			top: 40px;
			height: calc(100% - 8vh);
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			z-index: 1;
		}
	}

	.coop {
		font-family: $ff-sans;
		font-size: 22px;
		line-height: 33px;

		@media (max-width: $breakpoint-mobile) {
			font-size: 14px;
			line-height: 21px;
		}

		.coop-text {
			display: block;
		}

		.coop-image {
			display: block;
		}

		:global(.coop-logo) {
			width: 300px;

			@media (max-width: $breakpoint-tablet) {
				width: 250px;
			}

			@media (max-width: $breakpoint-mobile) {
				width: 150px;
			}
		}
	}
</style>
